import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Delegation } from 'src/app/utils/interfaces/new/delegation.interface';
import { environment } from 'src/environments/environment';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class DelegationService {

  private _wait = (ms) => new Promise(res => setTimeout(res, ms));

  private isMock = environment.mock;

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response'
  };

  private apiUri = environment.basePath + '/user/delegations';

  constructor(
    private _http: HttpClient,
    private _snack: SnackbarService
  ) { }

  public async findGivenDelegations(): Promise<Delegation[]> {
    try {
      const res = await this._http.get(this.apiUri + "/donnees", this.httpOptions).toPromise();
      const delegations = res.body as Delegation[];
      return delegations;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findReceivedDelegations(): Promise<Delegation[]> {
    try {
      const res = await this._http.get(this.apiUri + "/recues", this.httpOptions).toPromise();
      const delegations = res.body as Delegation[];
      return delegations;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(id: string) {
    try {
      const res = await this._http.get(this.apiUri + '/' + id, this.httpOptions).toPromise();
      const delegation = res.body as Delegation;
      return delegation;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async create(delegation: Delegation) {
    try {
      const res = await this._http.post(this.apiUri, delegation, this.httpOptions).toPromise();
      return res.body;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async delete(delegation: Delegation) {
    try {
      delegation.disabled = true;
      const res = await this._http.delete(this.apiUri + '/' + delegation.id, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(delegation: Delegation) {
    try {
      const res = await this._http.put(this.apiUri + '/' + delegation.id, delegation, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

}
